import React, {Component} from 'react';
import {
  Button,
  Table
} from 'reactstrap';


import { FaPencilAlt, FaTrashAlt} from 'react-icons/fa';



class TablaUsuarios extends Component {


    render(){
        const {data, eliminar , editar ,filtro} = this.props; 
        return (
                <Table size="sm" striped bordered className="tabla-general">

                    <thead>
                      <tr>
                          <th>RUT</th>
                          <th>Nombre completo</th>
                          <th className="ocultar-en-somen">Email</th>
                          <th className="ocultar-en-somen">Comuna</th>
                          <th className="ocultar-en-somen">Tipo de usuario</th>
                          <th className="centrado">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>

                    {
                    


                    filtro!=='' && filtro!==null && filtro!==undefined?

                        data.filter(user => user.id === filtro.value)
                        .map(u =>  
                            <tr key={u.id}>
                            <td>{u.id}</td>
                            <td>{u.nombres} {u.apellidos}</td>
                            <td className="ocultar-en-somen">{u.email}</td>
                            <td className="ocultar-en-somen">{u.comuna}</td>
                            <td className="ocultar-en-somen">{u.tipoUsuario_nombre}</td>
                            <td className="text-center td-botones">
                                <Button color="secondary" className="btn-tabla" onClick={()=>editar(u)} > <FaPencilAlt/></Button>
                                <Button color="danger" className="btn-tabla"  onClick={()=>eliminar(u.id)}  ><FaTrashAlt/></Button>
                            </td>
                        </tr>)
                        
                        : 
                        
                        data.map(u => {
                            return (
                                <tr key={u.id}>
                                    <td>{u.id}</td>
                                    <td>{u.nombres} {u.apellidos}</td>
                                    <td className="ocultar-en-somen">{u.email}</td>
                                    <td className="ocultar-en-somen">{u.comuna}</td>
                                    <td className="ocultar-en-somen">{u.tipoUsuario_nombre}</td>
                                    <td className="text-center td-botones">
                                        <Button color="secondary" className="btn-tabla" onClick={()=>editar(u)} > <FaPencilAlt/></Button>
                                        <Button color="danger" className="btn-tabla"  onClick={()=>eliminar(u.id)}  ><FaTrashAlt/></Button>
                                    </td>
                                </tr>
                            )  
                        })

                    }


                    </tbody>

                </Table>    

        );

    }
};

export default TablaUsuarios;
